import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Paper from '@mui/material/Paper';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Collapse from '@mui/material/Collapse';
import Fade from '@mui/material/Fade';
import WbIncandescentOutlinedIcon from '@mui/icons-material/WbIncandescentOutlined';
import CodeIcon from '@mui/icons-material/Code';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import { Trans, withTranslation, useTranslation } from 'react-i18next';

const ConditionalQuerySection = ({ languages, t }) => {
  const [collapsed, setCollapsed] = useState(true);
  const [copied, setCopied] = useState(false);

  const handleToggleBtn = () => {
    setCollapsed(!collapsed);
  }

  const getCode = () => {
    let codeStr = '';
    languages.forEach((lang, index) => {
      if(index === 0) {
        codeStr += `{% if request.locale.iso_code == '${lang.code}' %}\n    // ${lang.name.toUpperCase()} CODE HERE ...\n`;
      }
      if(index !== 0 && index !== languages.length-1) {
        codeStr += `{% elsif request.locale.iso_code == '${lang.code}' %}\n    // ${lang.name.toUpperCase()} CODE HERE ...\n`;
      }
      if(index === languages.length-1) {
        codeStr += `{% else %}\n    // ${lang.name.toUpperCase()} CODE HERE ...\n{% endif %}`;
      }
    });
    return codeStr;
  }

  return(<Paper sx={styles.infoBox} elevation={0}>
    <Typography variant="h6" sx={styles.infoText} style={{ margin: '4px 0 0 0', fontSize: 16, position: 'relative' }}>
      <WbIncandescentOutlinedIcon style={{ fontSize: 24, margin: '0 8px 4px 0' }} />
      <Trans i18nKey={'pages.theme.developerHint'}></Trans>
      <Button onClick={handleToggleBtn} variant="contained" size="small" color="primary" sx={styles.toggleCode}>{collapsed ? t('pages.theme.showCode') : t('pages.theme.hideCode')} <CodeIcon size="small" style={{marginLeft: 4}}/></Button>
    </Typography>
    <Collapse in={!collapsed}>
      <CopyToClipboard text={getCode()} onCopy={() => { setCopied(true); setTimeout(() => { setCopied(false); }, 3000)}}>
        <div style={styles.codeContainerInline}>
          <Typography sx={styles.codeText} component="span" fullwidth="true">{getCode()}</Typography>
          <Fade in={copied}>
            <strong style={{position: 'absolute', borderRadius: 4, top: 0, bottom: 0, left: 0, right: 0, backgroundColor: 'var(--ly-backdrop)', alignItems: 'center', display: 'flex', justifyContent: 'center', fontSize: 16, fontWeight: 'bold'}}>{t('pages.theme.copied')}</strong>
          </Fade>
        </div>
      </CopyToClipboard>
    </Collapse>
  </Paper>)
}

const styles = {
  infoBox: (theme) => ({
    ...theme.mixins.frostedSurface(theme.palette.accentSurface.background),
    padding: '12px 16px',
    border: `solid 1px ${theme.palette.divider}`,
    marginTop: '20px',
  }),
  infoText: {
    color: 'accentSurface.text',
    paddingRight: '135px',
  },
  codeContainerInline: {
    position: 'relative',
    margin: '16px 0 4px 0',
    cursor: 'pointer',
    padding: '8px',
    backgroundColor: 'background.paper',
    border: 'solid 1px',
    borderColor: 'divider',
    borderRadius: '4px'
  },
  codeText: {
    fontSize: '12px',
    whiteSpace: 'pre',
  },
  toggleCode: {
    position: 'absolute',
    top: '-4px',
    right: 0,
  }
};

export default withTranslation()(ConditionalQuerySection);
